import React from 'react';
import './OtofDetails.scss';

export const OtofDetails = ({ details }) => {
  if (!details) return '';
  return (
    <div className='otofDetails tooltip'>
      <h3 className='tooltipHeading'>OTOF Details</h3>
      <div className='entries'>
        <p className='title'>First entry point reached time</p>
        <p className='value'>{details.rider_reached_time}</p>
      </div>
      <div className='entries'>
        <p className='title'>Delivery time</p>
        <p className='value'>{details.arrival_time}</p>
      </div>
      <div className='entries'>
        <p className='title'>OTOF promised time</p>
        <p className='value'>{details.promise_time}</p>
      </div>
      <div className='entries'>
        <p className='title'>Eligible for moneyback</p>
        <p className='value'>{details.eligible_for_moneyback}</p>
      </div>
      {details.ineligible_reason ? (
        <div className='entries'>
          <p className='title'>Ineligible reason</p>
          <p className='value'>{details.ineligible_reason}</p>
        </div>
      ) : null}
      <div className='entries'>
        <p className='title'>Moneyback claimed</p>
        <p className='value'>{details.moneyback_claimed}</p>
      </div>
      <div className='entries'>
        <p className='title'>Promo generated</p>
        <p className='value'>{details.moneyback_generated}</p>
      </div>
    </div>
  );
};
